var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardeletegrayx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.25,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58302 5.2038C6.13241 4.75319 5.40184 4.75319 4.95123 5.2038C4.50063 5.6544 4.50063 6.38498 4.95123 6.83558L8.55855 10.4429L5.33612 13.6653C4.88551 14.1159 4.88551 14.8465 5.33612 15.2971C5.78672 15.7477 6.5173 15.7477 6.9679 15.2971L10.1903 12.0747L13.4128 15.2971C13.8634 15.7477 14.594 15.7477 15.0446 15.2971C15.4952 14.8465 15.4952 14.1159 15.0446 13.6653L11.8221 10.4429L15.4294 6.83558C15.88 6.38498 15.88 5.6544 15.4294 5.2038C14.9788 4.75319 14.2483 4.75319 13.7977 5.2038L10.1903 8.81112L6.58302 5.2038Z",
    fill: "#C1C1C1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardeletegrayx);
export default __webpack_public_path__ + "static/media/car delete gray x.967f7966e0f3cb8aea9b4af99240551b.svg";
export { ForwardRef as ReactComponent };